const componentStyles = () => ({
  mainContent: {
    maxWidth: "100%",
    minHeight: "calc(100vh - 70px)",
  },
});

export default componentStyles;
